import AOS from 'aos';

export function initAOS(): void {
  AOS.init({
    duration: 800,
    easing: 'ease-out-cubic',
    once: true,
    offset: 100,
    delay: 0,
  });
}
